<template>
  <div class="ai-texts">
    <card title="Entities">
      <div class="row">
        <div class="col-md-6">
          <label>{{ $route.query.type.toUpperCase() }}</label>
          <el-select v-model="selectedEntities"
                     :placeholder="$route.query.type"
                     no-data-text="No data"
                     no-match-text="No match"
                     filterable
                     reserve-keyword
                     multiple
                     value-key="id">
            <el-option v-for="entity in entityList"
                       :key="entity.id"
                       :label="entity.name.en"
                       :value="entity">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-6">
          <label>COUNTRIES</label>
          <el-select v-model="selectedCountries"
                     placeholder="Countries"
                     no-data-text="No data"
                     no-match-text="No match"
                     filterable
                     reserve-keyword
                     multiple
                     value-key="id">
            <el-option v-for="country in countries"
                       :key="country.id"
                       :label="country.name.en"
                       :value="country">
            </el-option>
          </el-select>
        </div>
      </div>
    </card>
    <card title="Data for preview">
      <div class="row">
        <div class="col-md-2">
          <base-input label="Language"
                      :value="lang"
                      disabled
                      placeholder="New agent name">
          </base-input>
        </div>
        <div class="col-md-2">
          <base-input label="Text type"
                      :value="$route.query.textType"
                      disabled
                      placeholder="New agent name">
          </base-input>
        </div>
        <div class="col-md-3">
          <base-input label="Text alias"
                      :value="alias"
                      disabled
                      placeholder="New agent name">
          </base-input>
        </div>
        <div class="col-md-3">
          <label>Model name *</label>
          <el-select v-model="agentData.model"
                     placeholder="Model name *"
                     no-data-text="No data"
                     no-match-text="No match"
                     filterable
                     reserve-keyword>
            <el-option v-for="modelName in modelsNames"
                       :key="modelName"
                       :label="modelName"
                       :value="modelName">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-2">
          <label>Temperature *</label>
          <el-select v-model="agentData.temperature"
                     placeholder="Temperature *"
                     no-data-text="No data"
                     no-match-text="No match"
                     filterable
                     reserve-keyword>
            <el-option v-for="temperature in temperatures"
                       :key="temperature"
                       :label="temperature"
                       :value="temperature">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-16">
        <div class="col-12">
          <div v-for="(item, index) in filters"
               :key="index"
               class="ai-texts__checkboxes mb-16">
            <el-checkbox v-model="item.checked" @change="addJsonPayloadToPromt(item)">
              {{ item.label }}
            </el-checkbox>
            <template v-if="item.checked">
              <el-input
                v-model="item.inputValue"
                :autosize="{ minRows: 2 }"
                type="textarea"
                class="mt-16"
                placeholder='Example: { "min_price": 1000, "ids": [1, 13, 1454] }'
              />
              <el-input
                v-if="item.prettyJson"
                :value="item.prettyJson"
                :autosize="{ minRows: 2 }"
                type="textarea"
                class="mt-16"
              />
              <div class="mt-16">
                <base-button type="btn-simple btn-sm"
                             @click="validateJSON(item.inputValue)"
                             class="mr-16">
                  Validate JSON
                </base-button>
                <base-button type="btn-simple btn-sm"
                             :disabled="!item.inputValue"
                             @click="formatJSON(item)">Format JSON</base-button>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="row mt-16">
        <div class="col-12 align-items-center">
          <label>{{ $route.query.type.toUpperCase() }}:</label>
          <div>
            <base-button type="btn-simple btn-sm"
                         :class="{'btn-primary': isActiveBtn(entity, 'selectedEntitiesBtns') }"
                         class="mr-16 mb-16"
                         @click="addBtn(entity, 'selectedEntitiesBtns')"
                         v-for="entity in selectedEntities" :key="entity.id">
              {{ entity.name.en }}
            </base-button>
          </div>
        </div>
      </div>
      <div class="row mt-16">
        <div class="col-12 align-items-center">
          <label>COUNTRIES:</label>
          <div>
            <base-button type="btn-simple btn-sm"
                         :class="{'btn-primary': isActiveBtn(country, 'selectedCountriesBtns') }"
                         class="mr-16 mb-16"
                         @click="addBtn(country, 'selectedCountriesBtns')"
                         v-for="country in selectedCountries" :key="country.id">
              {{ country.name.en }}
            </base-button>
          </div>
        </div>
      </div>
      <div class="row mt-16">
        <div class="col-md-12">
          <label>Placeholders:</label>
          <div>
            <base-button type="btn-simple btn-sm"
                         class="mr-16 mb-16"
                         @click="insertTextAtCursor(placeholder)"
                         v-for="placeholder in placeholders" :key="placeholder">
              {{ placeholder }}
            </base-button>
          </div>
        </div>
        <div class="col-md-12">
          <label>Prompts editor *</label>
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="agentData.prompt"
            placeholder="Some prompt texts *"
            ref="inputRef"
          ></el-input>
        </div>
      </div>
      <div class="row mt-16">
        <div class="col-12">
          <base-button class="mr-16"
                       :disabled="!agentData.prompt"
                       @click="saveTemplate()">
            {{ agentData.template_id ? 'Update' : 'Save' }} template
          </base-button>
          <base-button class="btn btn-danger mr-16"
                       v-show="agentData.template_id"
                       @click="deleteTemplate()">
            Delete template
          </base-button>
          <base-button class="btn btn-primary mr-16"
                       v-show="agentData.template_id"
                       :disabled="!agentData.prompt"
                       @click="generateText({ isPreview: true })">
            Preview generation
          </base-button>
          <base-button class="btn btn-success mr-16"
                       v-show="agentData.template_id"
                       :disabled="!agentData.prompt"
                       @click="generateText({ isPreview: false })">
            Prod generation
          </base-button>
        </div>
      </div>
    </card>
    <card title="Request result" v-if="responseData">
      <table class="table table-responsive">
        <tr>
          <th>Entity</th>
          <th>Country</th>
          <th>Text</th>
          <th>Copy</th>
          <th>GPT JSON Payload</th>
        </tr>
        <tr v-for="result in responseData">
          <td>{{result.entity_name}}</td>
          <td>{{result.country_name}}</td>
          <td v-html="result.text_result[lang] || result.text_result.en"></td>
          <td><base-button class="btn btn-success btn-sm" @click="clipBoard(result.text_result[lang] || result.text_result.en)">Copy text</base-button></td>
          <td>
            <base-button class="btn btn-primary btn-sm"
                         @click="isGPTJSONVisible = true;GPTJSONData = result.gpt_json_payload"
                         v-show="result.gpt_json_payload && result.gpt_json_payload.length">
              Open GPT JSON Payload
            </base-button>
          </td>
        </tr>
      </table>
    </card>
    <el-dialog :visible.sync="isGPTJSONVisible"
               width="80%">
      <h3>GPT JSON Payload</h3>
      <card :title="Object.keys(gptItem)[0].toUpperCase()"
            v-for="(gptItem, key) in GPTJSONData"
            :key="Object.keys(gptItem)[0]">
        <template v-if="Object.keys(gptItem)[0] === 'reviews'">
          <div class="row" v-for="(review, index) in Object.values(gptItem)[0]" :key="index">
            <div class="col-12">
              {{ review }}
            </div>
          </div>
        </template>
        <template v-else>
          <table class="table table-responsive">
            <tr>
              <th v-for="(content, key) in Object.values(gptItem)[0][0]" :key="key">
                {{key}}
              </th>
            </tr>
            <tr v-for="(a, b) in Object.values(gptItem)[0]" :key="b">
              <td v-for="(c, d) in Object.values(gptItem)[0][b]" :key="d" style="max-width: 300px">
                {{c}}
              </td>
            </tr>
          </table>
        </template>
      </card>
<!--      <base-button-->
<!--        type="primary"-->
<!--        class="mt-16"-->
<!--        @click="clipBoard('text')">Copy</base-button>-->
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { BaseAlert } from "@/components";
import APIAi from '@/api/modules/ai';

export default {
  components: { BaseAlert },
  data: () => ({
    GPTJSONData: null,
    isGPTJSONVisible: false,
    alias: null,
    lang: null,
    initEntity: null,
    entityList: '',
    selectedEntities: [],
    selectedEntitiesBtns: [],
    selectedCountries: [],
    selectedCountriesBtns: [],
    temperatures: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    agentData: {},
    placeholders: [
      '{operation}',
      '{illness}',
      '{speciality}',
      '{diagnostic}',
      '{country}',
    ],
    filters: [
      { label: 'Reviews', checked: false, inputValue: '' },
      { label: 'Personal Offers', checked: false, inputValue: '' },
      { label: 'Prices', checked: false, inputValue: '' },
      { label: 'Top Clinics', checked: false, inputValue: '' },
      { label: 'Top doctors', checked: false, inputValue: '' },
      { label: 'Search', checked: false, inputValue: '' },
    ],
    initAgentData: {
      prompt: '',
      model: 'gpt-4.1',
      temperature: 0.5,
    },
  }),
  computed: {
    ...mapState('cmsApiCatalogs', [
      'operation',
      'diagnostic',
      'illness',
      'illness-kind',
      'countries',
      'operations',
      'illnesses',
      'diagnostics',
      'illness-kinds',
    ]),
    ...mapState('chatApi', ['modelsNames']),
    ...mapState('ai', ['textTemplates', 'requestResult']),
    responseData() {
      return this.requestResult?.response_data?.length ? this.requestResult.response_data : null;
    },
    dataForTemplate() {
      const extra_data = this.filters.filter((item) => item.checked).reduce((acc, item) => {
        acc[item.label.toLowerCase().replace(/\s/g, '_')] = {
          active: true,
          filter: item.inputValue,
        };
        return acc;
      }, {});
      return {
        type: this.$route.query.textType,
        alias: this.alias,
        countries: this.selectedCountries?.length ? this.selectedCountries.map(country => country.code) : [],
        lang: this.lang.toUpperCase(),
        [this.$route.query.type === 'illnesses_kinds' ? 'illness_kinds' : this.$route.query.type]: this.selectedEntities?.length ? this.selectedEntities.map(entity => entity.id) : [],
        ...this.agentData,
        extra_data,
      };
    },
  },
  created() {
    this.initData();
    this.getModelsName();
  },
  methods: {
    ...mapActions('cmsApiCatalogs', [
      'getCountries',
      'getOperations',
      'getIllnesses',
      'getDiagnostics',
      'getIllnessKinds',
      'getEntity',
    ]),
    ...mapActions('chatApi', ['getModelsName']),
    ...mapActions('ai', ['getTextTemplates', 'getRequestResult']),
    generateText({ isPreview = false }) {
      const { dataForTemplate } = this;
      if (this.checkJsonBeforeSave()) {
        dataForTemplate.extra_data = this.filters.filter(item => item.checked).reduce((acc, item) => {
          acc[item.label.toLowerCase().replace(/\s/g, '_')] = {
            active: true,
            filter: item.inputValue ? JSON.parse(item.inputValue) : {},
            limit: 5
          };
          return acc;
        }, {});
      } else {
        return;
      }
      const data = {
        ...dataForTemplate,
        countries: this.selectedCountriesBtns?.length ? this.selectedCountriesBtns.map(country => country.code) : [],
        [this.$route.query.type === 'illnesses_kinds' ? 'illness_kinds' : this.$route.query.type]: this.selectedEntitiesBtns?.length ? this.selectedEntitiesBtns.map(entity => entity.id) : [],
        preview: isPreview,
      };
      this.$store.dispatch('setLoader', true);
      return APIAi.generateText(data)
        .then(response => {
          if (response.data?.message && response.data?.request_id) {
            this.$notify({ type: 'success', title: response.data?.message });
            this.getRequestResultEvent(response.data.request_id);
          } else {
            this.$notify({ type: 'warning', title: 'No text generated' });
            this.$store.dispatch('setLoader', false)
          }
        })
        .catch(e => {
          this.$notify({ type: 'error', title: e.message || 'Generation failed' })
          this.$store.dispatch('setLoader', false)
        })
    },
    async getRequestResultEvent(request_id) {
      this.$store.dispatch('setLoader', true);
      try {
       await this.getRequestResult({ request_id });
        if (this.requestResult?.status === 'failed') {
          this.$store.dispatch('setLoader', false)
          this.$notify({ type: 'warning', title: 'Generation failed' });
        } else if (this.requestResult?.status !== 'completed') {
          setTimeout(() => this.getRequestResultEvent(request_id), 10000);
        } else {
          this.$store.dispatch('setLoader', false);
          this.$notify({ type: 'success', title: 'Generation completed' });
        }
      } catch (e) {
        this.$notify({ type: 'warning', title: e.message });
        this.$store.dispatch('setLoader', false)
      }
    },
    formatJSON(item) {
      try {
        const json = JSON.parse(item.inputValue);
        const prettyJson = JSON.stringify(json, null, 2);
        this.$set(item, 'prettyJson', prettyJson);
        this.$notify({ type: 'success', title: 'Formatted successfully' });
      } catch (e) {
        this.$notify({ type: 'warning', title: e.message });
      }
    },
    validateJSON(jsonString) {
      try {
        JSON.parse(jsonString);
        this.$notify({ type: 'success', title: 'Valid JSON' });
      } catch (e) {
        this.$notify({ type: 'warning', title: e.message });
      }
    },
    async getTextTemplatesEvent() {
      try {
        this.$store.dispatch('setLoader', true);
        await this.getTextTemplates({
          type: this.$route.query.textType,
          alias: this.alias,
          countries: this.selectedCountries?.length ? this.selectedCountries.map(country => country.code) : [],
        });
        if (this.textTemplates?.length) {
          const template = this.textTemplates[this.textTemplates.length - 1];
          this.selectedCountries = this.countries.filter((country) => template.countries.includes(country.code));
          this.selectedEntities = this.entityList.filter((entity) => {
            if (this.$route.query.type === 'illnesses_kinds') {
              return template.illness_kinds.includes(entity.id);
            }
            return template[this.$route.query.type].includes(entity.id);
          });
          this.agentData = {
            prompt: template.prompt,
            model: template.model,
            temperature: template.temperature,
          };
          if (template.template_id) {
            this.agentData.template_id = template.template_id;
          }
          if (Object.keys(template.extra_data)?.length) {
            this.filters.forEach(filter => {
              if (template.extra_data[filter.label.toLowerCase().replace(/\s/g, '_')]) {
                filter.checked = true;
                filter.inputValue = template.extra_data[filter.label.toLowerCase().replace(/\s/g, '_')].filter || '';
              } else {
                filter.checked = false;
                filter.inputValue = '';
              }
            });
          }
        }
      } catch (e) {
        this.$notify({ type: 'warning', title: 'Something wrong' });
      } finally {
        this.$store.dispatch('setLoader', false);
      }
    },
    async deleteTemplate() {
      try {
        this.$store.dispatch('setLoader', true);
        await APIAi.deleteTextTemplate({ template_id: this.agentData.template_id });
        this.agentData = JSON.parse(JSON.stringify(this.initAgentData));
        this.$notify({ type: 'success', title: 'Deleted' });
      } catch (e) {
        this.$notify({ type: 'warning', title: 'Delete Failed' });
      } finally {
        this.$store.dispatch('setLoader', false);
      }
    },
    checkJsonBeforeSave() {
      return this.filters.every(filter => {
        if (filter.checked && filter.inputValue?.length) {
          try {
            JSON.parse(filter.inputValue);
            return true;
          } catch (e) {
            this.$notify({ type: 'warning', title: `Invalid JSON in ${filter.label}` });
            return false;
          }
        }
        return true;
      });
    },
    async saveTemplate() {
      try {
        this.$store.dispatch('setLoader', true);
        const response = await APIAi[this.agentData?.template_id ? 'updateTextTemplate' : 'saveTextTemplate'](this.dataForTemplate);
        if (response.data?.template_id) {
          this.$set(this.agentData, 'template_id', response.data.template_id);
        }
        this.$notify({ type: 'success', title: 'Saved' });
      } catch (e) {
        this.$notify({ type: 'warning', title: 'Save Failed' });
      } finally {
        this.$store.dispatch('setLoader', false);
      }
    },
    insertTextAtCursor(text) {
      const input = this.$refs.inputRef.$el.querySelector('textarea');
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const before = this.agentData.prompt.slice(0, start);
      const after = this.agentData.prompt.slice(end);
      this.agentData.prompt = before + text + after;

      this.$nextTick(() => {
        const newPos = start + text.length;
        input.focus();
        input.setSelectionRange(newPos, newPos);
      });
    },
    addBtn(entity, listBtns) {
      if (!this[listBtns].some(selected => selected.id === entity.id)) {
        if (this[listBtns].length < 3) {
          this[listBtns].push(entity);
        } else {
          this.$notify({ type: 'warning', title: 'Max num - 3' })
        }
      } else {
        this[listBtns] = this[listBtns].filter(selected => selected.id !== entity.id);
      }
    },
    isActiveBtn(entity, list) {
      return this[list].some(selected => selected.id === entity.id);
    },
    async initData() {
      this.agentData = JSON.parse(JSON.stringify(this.initAgentData));
      this.$store.dispatch("setLoader", true);
      this.alias = this.$route.query.alias || '';
      this.lang = this.$route.query.lang || '';
      try {
        await this.getCountries({ perPage: 1500 });
        if (this.countries?.length && this.countries.find(country => country.id === +this.$route.query.countryId)) {
          const selectedCountry = this.countries.find(country => country.id === +this.$route.query.countryId);
          this.selectedCountries = [selectedCountry];
          this.selectedCountriesBtns = [selectedCountry];
        }
        if (this.$route.query.type === 'operations'
          || this.$route.query.type === 'illnesses'
          || this.$route.query.type === 'diagnostics') {
          if (this.$route.query.type === 'operations') {
            await this.getEntityEvent('operation', 'getOperations');
          } else if (this.$route.query.type === 'diagnostics') {
            await this.getEntityEvent('diagnostic', 'getDiagnostics');
          } else if (this.$route.query.type === 'illnesses') {
            await this.getEntityEvent('illness', 'getIllnesses');
          }
        } else if (this.$route.query.type === 'illnesses_kinds') {
          await this.getEntity({
            entityId: this.$route.query.entityId,
            type: 'illness-kind',
            entitiesString: 'illness-kinds',
          });
          this.initEntity = this['illness-kind'].illness_kind;
          await this.getIllnessKinds({ perPage: 1500 });
          this.entityList = this['illness-kinds'];
        }
        this.selectedEntities = [this.initEntity];
        this.selectedEntitiesBtns = [this.initEntity];
        await this.getTextTemplatesEvent();
      } catch(e) {} finally {
        this.$store.dispatch("setLoader", false);
      }
    },
    clipBoard(text) {
      navigator.clipboard.writeText(text);
      this.$notify({ type: 'success', title: 'Copied' });
    },
    addJsonPayloadToPromt(item) {
      if (item.label === 'Search') {
        return;
      }
      const label = item.label.toLowerCase().replace(/\s/g, '_');
      if (item.checked) {
        this.agentData.prompt += ` json_payload#${label}`;
      } else if (!item.checked) {
        const regex = new RegExp(`json_payload#${label}`, 's');
        this.agentData.prompt = this.agentData.prompt.replace(regex, '');
      }
    },
    async getEntityEvent(type, listType) {
      this.$store.dispatch("setLoader", true);
      try {
        await this.getEntity({ entityId: this.$route.query.entityId, type, entitiesString: this.$route.query.type });
        this.initEntity = this[type][type];

        const params = { perPage: 1500 };
        if (this.initEntity?.illnessKinds?.length || this.initEntity?.illnessKind?.id) {
          params.illnessKindIds = type === 'illness' ? [this.initEntity.illnessKind.id] : this.initEntity.illnessKinds.map(kind => kind.id);
        }
        await this[listType](params);
        this.entityList = this[this.$route.query.type];
      } catch(e) {} finally {
        this.$store.dispatch("setLoader", false);
      }
    }
  }
}
</script>

<style lang="scss">
.agent-bot__adding{
  display: flex;
  align-items: flex-end;
  gap: 16px;
  .form-group{
    width: 100%;
  }
  button{
    height: 40px;
    margin-bottom: 10px;
  }
}
</style>
